const NotificationComponent = {
    templateUrl: '/ui/notification/notification.tpl.html',
    controller: 'notificationController'
};

angular.module('umCore')
    .component('uiNotification', NotificationComponent);
